import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const PaginationWrapper = styled.div`
	display: flex;
	justify-content: ${props => props.position};
`;

export const PaginationContainer = styled.ul`
	display: flex;
	list-style-type: none;
`;

export const PaginationItem = styled.li`
	padding: 0 8px;
	height: 32px;
	text-align: center;
	margin: auto 2px;
	color: ${colors.black};
	box-sizing: border-box;
	letter-spacing: 0.01071em;
	border-radius: 4px;
	line-height: 1.43;
	font-size: 12px;
	min-width: 32px;
	align-content: center;
	&:hover {
		background-color: ${colors.green200};
		cursor: pointer;
	}

	${props =>
		props.dots && ':hover {background-color: transparent; cursor: default;}'};

	${props => props.selected && `background-color: ${colors.green400};`};

	${props => props.disabled && 'pointer-events: none;'};
`;

export const NavigationButton = styled.button`
	padding: 0;
	margin: 0 0 0 5px;
	border: none;
	transition: all 0.3;
	.material-icons-outlined {
		vertical-align: middle;
	}
	${props =>
		props.disabled
			? `pointer-events: none; cursor: default; .material-icons-outlined { color: ${
					colors.grey200
			  }; }`
			: `cursor: pointer; .material-icons-outlined { color: ${
					colors.black
			  }; }`};

	${props =>
		!props.disabled &&
		` &:hover {
    .material-icons-outlined {
      color: ${colors.green400};
    }
  }`};
`;
